import { enumParser } from '#validation/common/parsers';
import { PasswordLoginRequirement } from '../constants';
export const passwordLoginRequirementParser = enumParser(PasswordLoginRequirement);
